import React, { useRef, useState } from 'react'
import { useAddNewWasteCategoryuserappMutation, useGetUserappQuery } from './WasteCategorySlice';

function AddWasteCategory() {
    const [addUserApp, setAddUserApp] = useState({ name: "", unit_id: "", image: null, active: "", price: "" });
    const refClose = useRef(null);

    // User App api
    const {
        data: UserApp,
    } = useGetUserappQuery("getUserapp");

    // thies is Waste Category  data post api 
    const [addNewWasteCategoryuserApp, { isLoading }] = useAddNewWasteCategoryuserappMutation()

    // thies function is data save in state
    const handleChange = (e) => {
        if (e.target.name === "image") {
            setAddUserApp({ ...addUserApp, [e.target.name]: e.target.files[0] })
        } else {
            setAddUserApp({ ...addUserApp, [e.target.name]: e.target.value })
        }
    };


    const handleClick = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append('name', addUserApp.name);
            formData.append('image', addUserApp.image);
            formData.append('unit_id', addUserApp.unit_id);
            formData.append('active', addUserApp.active);
            formData.append('price', addUserApp.price);

            const response = await addNewWasteCategoryuserApp(formData).unwrap();

            console.log("response",response);
            
            setAddUserApp({ name: "", image: null, unit_id: "", active: "", price: "" });
            refClose.current.click();
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <>
            <button type="button" className="Add_button bg-left-navabr  text-light  btn btn-secondary" data-bs-toggle="offcanvas" data-bs-target="#depOffCanvas" aria-controls="depOffCanvas"><i className="fa fa-plus" aria-hidden="true"></i> Add Waste Category</button>

            <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="1" id="depOffCanvas" aria-labelledby="depOffCanvas">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Add  Waste Category</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref={refClose}></button>
                </div>
                <div className="offcanvas-body">
                    <div>
                        <form className="row g-3">
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="name"
                                    value={addUserApp.name}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="image" className="form-label font-weight-bold">
                                    Image
                                </label>
                                <input
                                    type="file"
                                    className="form-control"
                                    name="image"
                                    id="image"
                                    // onChange={(e) => { setImage(e.target.files[0]) }}
                                    // value={addUserApp.image}
                                    onChange={handleChange}
                                    multiple
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="unit" className="form-label font-weight-bold">
                                    Unit
                                </label>

                                <select className="form-select" id="unit_id" name="unit_id"
                                    value={addUserApp.unit_id} onChange={handleChange}
                                    required>
                                    <option value="" defaultValue>Select</option>
                                    {
                                        UserApp?.map((index, e) => {
                                            return <option value={index?.id} defaultValue>{index?.name}</option>
                                        })
                                    }
                                </select>
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="Price" className="form-label font-weight-bold">
                                    Price
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="price"
                                    name="price"
                                    value={addUserApp.price}
                                    onChange={handleChange}
                                    placeholder="price"
                                    autoComplete="off"
                                    required
                                />
                            </div>

                            {/* <div className="col-md-12 text-left">
                                <label htmlFor="type" className="form-label font-weight-bold">
                                    Active
                                </label>

                                <select className="form-select" id="active" name="active"
                                    value={addUserApp.active} onChange={handleChange}
                                    required>
                                    <option value="" defaultValue>Select</option>
                                    <option value="1" defaultValue>Yes</option>
                                    <option value="0" defaultValue>No</option>
                                </select>
                            </div> */}
                            <div className="col-md-12">
                                <button type="submit" className="btn btn-ff9b44 btn-block btn-round"
                                    onClick={handleClick}
                                    disabled={!(addUserApp.name)}
                                >
                                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div >
            </div >
        </>
    )
}

export default AddWasteCategory;